import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
} from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import "./Login.scss";
import logo from "../assets/images/logo.svg";
import { IoIosArrowRoundForward } from "react-icons/io";


const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const result = await login(email, password);

    if (!result.success) {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <section className="login-section">
      <Container
        fluid
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "100vh", background: "#FEEDE2" }}
      >
        <Row className="w-100 justify-content-center">
          <Col xs={12} sm={8} md={6} lg={4}>
            <Card className="shadow-lg">
              <Card.Body className="p-5">
                <div className="logo">
                  <img src={logo} alt="logo" />
                </div>
                <h4 className="fw-bold mb-4">
                  Welcome to our <br />
                  Leeds Management System
                </h4>

                {error && (
                  <Alert variant="danger" className="mb-3">
                    {error}
                  </Alert>
                )}

                <Form className="form" onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="email"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <div className="forget-box">
                    <Form.Check type="checkbox" label="Remember me" />
                    <a href="#">Forgot password?</a>
                  </div>

                  <button
                    className="w-100 btn-secondary"
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                    <IoIosArrowRoundForward size={22} className="ms-1" />

                  </button>
                </Form>

                <div className="text-center mt-4">
                  <small className="text-muted">
                    Demo credentials: admin@lms.com / admin123
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Login;
